<template>
  <div class="yxtbiz-shop-selector">
    <yxt-tabs
      v-model="activeName"
      :drawer-top="drawerTop"
      :before-leave="tabBeforeLeave"
    >
      <yxt-tab-pane
        v-for="(tab, index) in setTabs"
        :key="index"
        :name="tab.value"
      >
        <span slot="label">{{ tab.label }}</span>
        <yxt-row
          class="yxtbiz-shop-selector-container"
          type="flex"
        >
          <template v-if="activeName === tab.value">
            <component
              :is="tab.component"
              v-model="selectedProps"
              @update="update"
              @onProcess="onProcess"
            />
          </template>
          <aside class="yxtbiz-shop-selector__right">
            <div class="yxtbiz-shop-selector__right_count">{{$t('pc_biz_shoptour_select_info' /*已选择（{0}/1000）*/, [list.length, limit]).d(`已选择（${list.length}/${limit}`)}}</div>
            <div style="height: 100%">
              <yxtbiz-virtual-list
                is-scrollbar
                style="height: 100%;overflow: hidden;"
                :data-sources="list"
                data-key="storeId"
                :estimate-size="32"
                :keeps="50"
                item-tag="div"
              >
                <template slot-scope="{ source }">
                  <yxt-tag
                    @close="deleteItem(source)"
                    size="small"
                    type="info"
                    class="mb5 tag"
                    closable
                    :key="source.storeId"
                  >
                    <span class="yxtbiz-user-selector-tag">{{ source.storeName }}</span>
                  </yxt-tag>
                </template>
              </yxtbiz-virtual-list>
            </div>
            <yxt-button
              type="text"
              class="yxtbiz-shop-clear font-size-12 color-gray-9 hover-primary-6"
              :disabled="list.length === 0"
              @click="clear"
            >
              {{ $t('pc_biz_shoptour_clear_all' /*清除所有*/) }}
            </yxt-button>
          </aside>
        </yxt-row>
      </yxt-tab-pane>
    </yxt-tabs>
  </div>
</template>

<script>
import Area from './components/area';
import Category from './components/category';
import CheckList from './components/checkList';
export default {
  name: 'YxtbizShopSelector',
  components: {
    Area,
    Category,
    CheckList
  },
  props: {
    drawerTop: {
      default: true,
      type: Boolean
    },
    // string Or Object
    // Object:{label, value}  (value:slotName)
    tabs: {
      type: Array,
      default: () => []
    },
    data: { // 传入的已选数据
      type: Array,
      default: () => []
    },
    limit: { // 数量限制
      type: Number,
      default: 1000,
      validator(v) {
        return v >= 0;
      }
    }
  },
  data() {
    // 记录组件初始化的原始数据key值
    this.oldObjKeys = [];
    return {
      selectedObjs: {
        total: {} // 所有选中对象的storeId与对象的对应组合
      },
      selectedProps: [], // 选中对象的数组
      defaultTabs: [
        {
          label: this.$t('pc_biz_shoptour_tab_area' /* 按区域 */),
          value: 'area',
          component: 'Area'
        },
        {
          label: this.$t('pc_biz_shoptour_tab_category' /* 按分类 */),
          value: 'category',
          component: 'Category'
        }
      ],
      activeName: 'area',
      // 子组件状态，是否在处理内部数据（用于标记是否在导入用户流程中）
      processing: false,
      // 用于父组件调用，标记当前选门店组件在抽屉中是否需要关闭提示，true：需要提示，false：不需要提示
      showTip: false
    };
  },
  computed: {
    hasLimit() {
      return this.limit !== 0;
    },
    setTabs() {
      // 切换tab项
      if (this.tabs.length === 0) {
        return this.defaultTabs;
      } else {
        return this.tabs
          .map(tab => {
            if (typeof tab === 'string') {
              return this.defaultTabs.find(item => item.value === tab);
            } else if (typeof tab === 'object' && tab.label && tab.value) {
              return { ...tab };
            } else {
              return null;
            }
          })
          .filter(item => {
            return item !== null;
          });
      }
    },
    list() {
      // 获取选择项，展示在右侧
      return Object.values(this.selectedObjs.total);
    }
  },
  watch: {
    setTabs: {
      immediate: true,
      handler(v) {
        this.activeName = v[0].value;
      }
    },
    data(v) {
      this.clear();
      this.splitObj(v);
    }
  },
  created() {
    this.data.forEach(item => {
      this.selectedObjs.total[item.storeId] = item;
      this.selectedProps.push(item);
    });
    this.oldObjKeys = Object.keys(this.selectedObjs.total);
  },
  methods: {
    // data发生变化时选择项发生变化
    splitObj(items) {
      items.forEach(item => {
        this.selectedObjs.total[item.storeId] = item;
        this.selectedProps.push(item);
      });
    },
    // 删除一条数据
    deleteItem(item) {
      this.$delete(this.selectedObjs.total, item.storeId);
      this.selectedProps = Object.values(this.selectedObjs.total);
      this.emitChange();
    },
    // 清除所有选项
    clear() {
      this.selectedObjs.total = {};
      this.selectedProps = [];
    },
    // 对外触发数据变更事件
    emitChange() {
      this.showTipHandler();
    },
    // 选项变更事件回调
    update(items, isAdd) {
      if (!(items instanceof Array)) {
        items = [items];
      }
      let total = Object.assign({}, this.selectedObjs.total);

      items.forEach(item => {
        if (isAdd) {
          total[item.storeId] = item;
        } else {
          delete total[item.storeId];
        }
        // 更新相应类型的选中对象
      });

      this.$set(this.selectedObjs, 'total', total);
      this.selectedProps = Object.values(this.selectedObjs.total);
      this.emitChange();
    },
    // 有数量限制时超出的提示信息
    showLimitError() {
      this.$message.warning(
        this.$t('pc_biz_area_limit', [this.limit]).d(
          `门店数量不能超过${this.limit}`
        )
      );
      // this.$alert(this.$t('pc_biz_shoptour_msg_outRange' /* 已选人数超过限制，请检查 */), this.$t('pc_biz_shoptour_tcm_limitnum' /* 最多可选{x}条 */, { x: this.limit }), {
      //   confirmButtonText: this.$t('pc_biz_shoptour_tcm_checkbtn' /* 去检查 */),
      //   type: 'error'
      // });
    },
    // 获取已选数据的方法
    getSelected(isValidLimit = true) {
      /* eslint-disable no-undef */
      let userSet = new Set(Object.keys(this.selectedObjs.total));
      if (isValidLimit && this.hasLimit && userSet.size > this.limit) {
        this.showLimitError();
        return;
      }
      return isValidLimit ? Object.values(this.selectedObjs.total) : Object.values(this.selectedObjs.total).length;
    },
    // tab切换时教养
    tabBeforeLeave() {
      if (this.processing) {
        return this.$confirm(this.$t('pc_biz_shoptour_msg_closeMsg' /* 当前操作尚未保存，是否确认放弃？ */), this.$t('pc_biz_shoptour_tip' /* 提示 */), {
          confirmButtonText: this.$t('pc_biz_shoptour_btn_determine' /* 确定 */),
          cancelButtonText: this.$t('pc_biz_shoptour_btn_cancel' /* 取消 */),
          type: 'warning'
        });
      } else {
        return true;
      }
    },
    // 子组件处理状态变更
    onProcess(processing) {
      this.processing = processing;
      this.showTipHandler();
    },
    showTipHandler() {
      // 以下情况需要关闭提示：数据发现了变化或者子组件正在处理数据
      this.showTip = this.processing || JSON.stringify(this.oldObjKeys) !== JSON.stringify(Object.keys(this.selectedObjs.total));
    }
  }
};
</script>
